import React, { useEffect, useRef, useState } from "react";
import { Card } from "primereact/card";
import PresortDemo from "../components/table/DataTable";
import { useActionsHook } from "../hooks/useActionsHook";
import { createOrderToBox } from "../metadata/box";
import { Toast } from "primereact/toast";
import {
  useGetBoxQuery,
  useSetOrderToBoxMutation,
} from "../store/api/boxApi";
import { useGetOrderByTCodeQuery } from "../store/api/orderAPI";
import { useParams } from "react-router-dom";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";

export default function BoxSeems() {
  const createOrderToBoxTr = useTranslatedColumns(createOrderToBox);
  const boxRef = useRef(null);
  const { t } = useTranslation();
  const { boxId } = useParams();
  const [setOrderToBox] = useSetOrderToBoxMutation();
  const [formData, setFormData] = useState({
    boxId: boxId,
    desc: "test",
  });
  const [openBox, setOpenBox] = useState(null);
  const [orders, setOrders] = useState([]);
  const { data: order, isLoading: isLoadingOrder } = useGetOrderByTCodeQuery({
    tcode: formData.tcode,
    boxId: formData.boxId,
  });
  const { data: box, isLoading: isLoadingBox } = useGetBoxQuery({
    boxId: formData.boxId ?? boxId,
  });




  useEffect(() => {
    setOpenBox(state => ({
      ...state,
      v_weight: (state?.width * state?.height * state?.["length"]) / 6000
    }))
  }, [openBox?.width, openBox?.height, openBox?.length])

  const toast = React.useRef(null);
  const actions = useActionsHook([

  ]);



  useEffect(() => {
    if (Array.isArray(box) && box.length) {
      setOpenBox(box[0]);
    }
    if (boxRef.current) boxRef.current.focus();
  }, [box]);

  useEffect(() => {
    if (Array.isArray(order) && order) {
      if (formData.tcode == undefined) {
        setOrders([...order]);
        return;
      }
      if (
        !!order[0]?.tracking_code &&
        openBox?.tracking_code != order[0].tracking_code
      ) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: t("orderSavedAnother"),
          life: 3000,
        });
        return;
      }
      if (!openBox?.guid || !order[0] || order[0].status == 1) {
        toast.current.show({
          severity: "info",
          summary: "Success",
          detail: t("orderNoScunned"),
          life: 3000,
        });
        return;
      }
      if (orders.find((el) => order[0].guid == el.guid)) {
        toast.current.show({
          severity: "info",
          summary: "Success",
          detail: t("orderScunned"),
          life: 3000,
        });
        return;
      }
      setOrderToBox({
        codeid: undefined,
        guid: undefined,
        order: order[0].guid,
        box: openBox.guid,
        desc: formData.desc,
      });

      setOrders([...orders, order[0]]);
    }
  }, [order]);
  const lastYearTotal = () => {
    let width = 0;
    let height = 0;
    let length = 0;
    let v_weight = 0;
    let gross_weight = 0;

    for (let sale of orders) {
      width += sale.width;
      height += sale.height;
      length += sale.length;
      v_weight += sale.v_weight;
      gross_weight += sale.gross_weight;
    }
    return {
      width: width,
      height: height,
      length: length,
      v_weight: v_weight,
      gross_weight: gross_weight,
    };
  };
  const totals = lastYearTotal()
  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          footer={t("results")}
          colSpan={5}
          footerStyle={{ textAlign: "right" }}
        />
        <Column footer={""} />
        <Column footer={""} />
        <Column footer={""} />
        <Column footer={totals.v_weight} />
        <Column footer={parseFloat(totals.gross_weight).toFixed(2)} />
      </Row>
    </ColumnGroup>
  );
  return (
    <>
      <Toast ref={toast} />
      <Card>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            width: "100%",
          }}
        >{boxId}
        </div>
        <PresortDemo
          isLoading={false}
          data={orders}
          column={createOrderToBoxTr}
          toggleSidebar={() => {
          }}
          maxHeight={"calc(100vh - 160px)"}
          footerColumnGroup={footerGroup}
          deleteHandler={(row, field) => {
            console.log(row, field);
          }}
          actions={actions}
        />
      </Card>
    </>
  );
};




